import { render, staticRenderFns } from "./LinkVariant.vue?vue&type=template&id=3834522c&"
import script from "./LinkVariant.vue?vue&type=script&lang=js&"
export * from "./LinkVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports